import { html } from "lit";
var icon_noConnection_default = () => html`
  <svg stroke-fill viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.3 29.5a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z"
      stroke-width="2"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M17.21 27.39 27.39 17.2" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M14.15 29.37A13.5 13.5 0 1 1 29.38 14.2"
      stroke-width="2"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M12.75 29.1C10.92 26.44 9.7 21.57 9.7 16s1.22-10.43 3.05-13.1"
      stroke-width="2"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M2.53 15.1H14.2" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.2 7.9h21.6" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4.06 22.3h6.2" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M19.25 2.9a20.41 20.41 0 0 1 2.77 8.6"
      stroke-width="2"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
`;
export {
  icon_noConnection_default as default
};
//# sourceMappingURL=icon-noConnection.js.map
